import { useLocation } from "react-router-dom";

import { SystemSettingsGroup, systemSettingsNav } from "../SystemSettings.config";

// Longest prefix rather than an exact match, so a redirect target such as /courts -> /courts/vienna
// still resolves to the "Gerichte" group.
export function useActiveSystemSettingsNav(): SystemSettingsGroup {
  const { pathname } = useLocation();

  let active: { group: SystemSettingsGroup; to: string } | undefined;
  for (const { group, entries } of systemSettingsNav) {
    for (const entry of entries) {
      const matches = pathname === entry.to || pathname.startsWith(`${entry.to}/`);
      if (matches && entry.to.length > (active?.to.length ?? -1)) {
        active = { group, to: entry.to };
      }
    }
  }

  return active?.group ?? systemSettingsNav[0].group;
}
